import { render, staticRenderFns } from "./Floorplan.vue?vue&type=template&id=2dcb1610&"
import script from "./Floorplan.vue?vue&type=script&lang=js&"
export * from "./Floorplan.vue?vue&type=script&lang=js&"
import style0 from "./Floorplan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports